class CollectionAside extends HTMLElement {
  constructor() {
    super();

    this.openBtn = null;
    this.closeBtn = null;
    this.resetBtn = null;

    this.isOpen = false;

    this.onOpenClick = this.onOpenClick.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onGlobalClick = this.onGlobalClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
     this.onFiltersApplied = this.onFiltersApplied.bind(this);
  }

  connectedCallback() {
    this.sidebar = this;

    this.openBtn = document.getElementById("mobile-filter-btn");
    this.closeBtn = this.querySelector(".close-btn");
    this.resetBtn = this.querySelector(".reset-btn");

    if (this.openBtn) {
      this.openBtn.addEventListener("click", this.onOpenClick, { passive: true });
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", this.onCloseClick, { passive: true });
    }

    // Close on outside click
    document.body.addEventListener("click", this.onGlobalClick);

    // Close on ESC
    document.addEventListener("keydown", this.onKeyDown);


    document.addEventListener("filters-applied", this.onFiltersApplied);

  }

  disconnectedCallback() {
    if (this.openBtn) {
      this.openBtn.removeEventListener("click", this.onOpenClick);
    }

    if (this.closeBtn) {
      this.closeBtn.removeEventListener("click", this.onCloseClick);
    }

    document.body.removeEventListener("click", this.onGlobalClick);
    document.removeEventListener("keydown", this.onKeyDown);
  }

  // ==========================
  // LOGIC
  // ==========================
  onOpenClick(e) {
    e.stopPropagation();
    this.open();
  }

    onFiltersApplied() {
    if (this.isOpen) this.close();
  }

  onCloseClick(e) {
    e.stopPropagation();
    this.close();
  }

  open() {
    if (this.isOpen) return;
    this.isOpen = true;

    this.classList.add("open");
    this.setAttribute("aria-expanded", "true");
  }

  close() {
    if (!this.isOpen) return;
    this.isOpen = false;

    this.classList.remove("open");
    this.setAttribute("aria-expanded", "false");
  }

  onGlobalClick(e) {
    if (!this.isOpen) return;

    const path = e.composedPath(); 
    if (!path.includes(this) && e.target !== this.openBtn) {
      this.close();
    }
  }

  onKeyDown(e) {
    if (e.key === "Escape" && this.isOpen) {
      this.close();
    }
  }
}

customElements.define("collection-aside", CollectionAside);
